export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[550px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashionable%20shopping%20bags%20in%20various%20sizes%20arranged%20on%20sleek%20marble%20countertop%20with%20folded%20clothing%20peeking%20out%2C%20soft%20evening%20ambient%20lighting%20with%20warm%20golden%20undertones%2C%20luxury%20retail%20experience%20aesthetic%2C%20clean%20modern%20boutique%20interior%20photography%20style%20with%20sophisticated%20warm%20neutral%20palette&width=1800&height=900&seq=cta-bg-2026-kakobuy-unique&orientation=landscape"
          alt="Kakobuy Spreadsheet - odkryj najlepsze okazje"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/40 via-foreground-900/25 to-foreground-900/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
            Gotowy na zakupy?
          </h2>
          <p className="text-white/80 text-base md:text-lg mb-8 max-w-lg mx-auto leading-relaxed">
            Przejdź do głównego arkusza Kakobuy i zacznij odkrywać najlepsze produkty już teraz. Tysiące produktów czeka na Ciebie.
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-all duration-200 cursor-pointer group"
          >
            <span className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-shopping-bag-line text-white text-base"></i>
            </span>
            <span className="text-base font-semibold uppercase tracking-wider whitespace-nowrap">Buy It Now</span>
            <i className="ri-arrow-right-up-line text-white/60 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
          </a>

          <div className="flex flex-wrap items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-white">1000+</div>
              <div className="text-white/60 text-xs mt-1">Produktów</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-white">14</div>
              <div className="text-white/60 text-xs mt-1">Kategorii</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-white">24/7</div>
              <div className="text-white/60 text-xs mt-1">Dostępność</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-white">0 zł</div>
              <div className="text-white/60 text-xs mt-1">Za darmo</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}